import React from 'react';
import {gsap} from 'gsap';

type SetPlaceHolder = (val: string) => void;

const addWord = (
    tl: gsap.core.Timeline,
    word: string,
    setPlaceholder: SetPlaceHolder,
) => {
    const chars = word.split('');

    let buffer = '';
    chars.forEach(char => {
        buffer += char;
        const partialWord = buffer;
        tl.call(() => {
            setPlaceholder(partialWord);
        }).to({}, {duration: 0.2});
    });
};

const removeWord = (
    tl: gsap.core.Timeline,
    word: string,
    setPlaceholder: SetPlaceHolder,
) => {
    const chars = word.split('');

    for (let i = chars.length; i >= 0; i--) {
        tl.call(() => {
            const newPlaceholder = word.substring(0, i);
            if (newPlaceholder.length === 0) {
                setPlaceholder(' ');
            } else {
                setPlaceholder(newPlaceholder);
            }
        }).to({}, {duration: 0.2});
    }
};

const blink = (
    tl: gsap.core.Timeline,
    currentWord: string,
    setPlaceholder: SetPlaceHolder,
    loops = 5,
) => {
    for (let i = 0; i < loops; i++) {
        tl.call(() => {
            setPlaceholder(`${currentWord}_`);
        })
            .to({}, {duration: 0.5})
            .call(() => {
                setPlaceholder(`${currentWord} `);
            })
            .to({}, {duration: 0.5});
    }
};

export default () => {
    const [placeholder, setPlaceholder] = React.useState('');

    React.useEffect(() => {
        if (placeholder === '') {
            const tl = gsap.timeline();

            blink(tl, '', setPlaceholder);
            addWord(tl, 'Antihypertensives', setPlaceholder);
            blink(tl, 'Antihypertensives', setPlaceholder);
            removeWord(tl, 'Antihypertensives', setPlaceholder);
            blink(tl, '', setPlaceholder, 2);
            tl.call(() => {
                setPlaceholder('');
            });
        }
    }, [placeholder]);

    return placeholder;
};
